import { OPERATION_ENDING_STATUS } from './end-operation.constants';

export const emitOperationEndingStatus = (isValid: boolean) => ({
    type: OPERATION_ENDING_STATUS,
    payload: {
        isValid
    }
});
